import {createEntityAdapter} from '@reduxjs/toolkit';
import {CheckInStatus} from '../entities';

export const checkInStatusesAdapter = createEntityAdapter<CheckInStatus>();
